import React from 'react';
import { AlertCircle, RefreshCw, X } from 'lucide-react';
export const SaveFailedBanner = ({ onRetry, onDismiss }) => {
    return (React.createElement("div", { role: "alert", style: {
            position: 'absolute',
            top: '16px',
            left: '50%',
            transform: 'translateX(-50%)',
            zIndex: 50,
            maxWidth: '450px',
            width: '100%',
            animation: 'slideInFromTop 0.3s ease-out',
        } },
        React.createElement("div", { className: "bg-white rounded-lg shadow-lg border-l-4 border-red-500 p-4 flex items-start gap-3" },
            React.createElement(AlertCircle, { className: "w-5 h-5 text-red-500 flex-shrink-0 mt-0.5" }),
            React.createElement("div", { className: "flex-1 min-w-0" },
                React.createElement("div", { className: "flex items-center justify-between gap-2 mb-1" },
                    React.createElement("h4", { className: "font-semibold text-gray-900 text-sm" }, "Error"),
                    React.createElement("button", { onClick: onDismiss, className: "text-gray-400 hover:text-gray-600 transition-colors flex-shrink-0", "aria-label": "Dismiss" },
                        React.createElement(X, { className: "w-4 h-4" }))),
                React.createElement("p", { className: "text-sm text-gray-600 mb-2" },
                    "Your changes could not be saved. Please retry, and if the issue persists, contact support at",
                    ' ',
                    React.createElement("a", { href: "mailto:support@placeholder.com", className: "text-red-600 underline" }, "support@placeholder.com"),
                    "."),
                React.createElement("button", { onClick: onRetry, className: "inline-flex items-center gap-2 px-3 py-1.5 text-sm font-medium text-white bg-red-600 hover:bg-red-700 rounded-md transition-colors" },
                    React.createElement(RefreshCw, { className: "w-4 h-4" }),
                    "Retry")))));
};
